/* eslint-disable */
import React, { useContext, useRef, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import "../../Assets/css/fileUpload.css"; // Create this CSS file for styling
import { FaUpload } from "react-icons/fa";
import UploadIcon from "@mui/icons-material/Upload";
import { FiUpload } from "react-icons/fi";

const FileUploadComponent = ({
  showAbortIcon,
  onUpload,
  file,
  fileInputRef,
  progress,
  showProgressbar,
  handleStopUploadOperation,
  showTabs,
  handleTabs,
  activeTab,
  showUploadComponent = false,
  accept,
  setFileType,
  fileStorage, // for aligning the component
}) => {
  // let disabledTextColor = 'rgb(0 135 255 / 61%)';
  // let defaultTextColor = "#0087ff";

  return (
    <div className={`wrapper gap-0`}>
      {showTabs && (
        <div
          className={`tabs-section ${
            activeTab === "Output" ? "output-active" : ""
          }`}
        >
          {["Input", "Output"].map((tab) => (
            <div
              key={tab}
              className="grid-tab-wrapper"
              onClick={() => handleTabs(tab)}
            >
              <div
                className={`grid-tab ${activeTab === tab ? "active-tab" : ""}`}
              >
                <span>{tab === "Input" ? "Input Files" : "Output Files"}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* {showTabs && (
                <div className="tabs-section">
                    {['input', 'output'].map((tab, index) => (
                        <button onClick={() => handleTabs(tab)}
                            style={{ position: 'relative', width: '7rem', backgroundColor: 'transparent', height: '3rem', border: 'none' }}>
                            <div
                                className={`d-flex align-items-center justify-content-center grid-tab ${activeTab === tab ? 'bg-white active-tab' : 'bg-transparent'}`}
                            >
                                <span>{tab == 'input' ? 'Input Files' : 'Output Files'}</span>
                            </div>
                        </button>
                    ))}
                </div>
            )} */}
      {(showUploadComponent || (showTabs && activeTab === "Input")) && (
        <div
          className="drag-area"
          onClick={() => fileInputRef?.current?.click()}
        >
          <h6 className="p-0 m-0 d-flex align-items-center">
            <div
              className={`d-flex align-items-center ${
                fileStorage ? "ps-0" : "ps-2"
              }`}
            >
              {/* style={{ padding: '3px 0px 3px 8px' }} */}
              <span className="choose-file-highlight me-0 ">
                <FiUpload size={17} color="#0087ff" className="" />
                <span className="upload-file">Upload File </span>
              </span>
            </div>
            <div className="d-flex align-items-center ms-1 drag-drop-title">
              {" "}
              or Drop File on the table{" "}
            </div>
          </h6>
          <div className="d-flex align-items-center">
            <input
              id="fileInput"
              type="file"
              multiple
              accept={accept}
              ref={fileInputRef}
              onChange={(e) => onUpload(e.target.files[0])}
              className="hidden-input"
            />
          </div>
        </div>
      )}
      {showProgressbar && (
        <div className="upload-overlay">
          <div className="upload-progress-card">
            <div className="upload-header">
              <span>Uploading...</span>
              {showAbortIcon && (
                <RxCross2
                  size={18}
                  className="upload-cancel"
                  onClick={handleStopUploadOperation}
                />
              )}
            </div>
            <div className="file-progress">
              <div className="file-label">
                <span className="file-name" title={file.name}>
                  {file.name}
                </span>
                <span className="file-percent">{progress || 0}%</span>
              </div>
              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${progress || 0}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadComponent;
